import styled from '@emotion/styled';

import { scrollbarStyles } from '../../scrollbar';
import { typographyVariantStyles } from '../../typography-variants';

const TRANSIENT_PROPS = new Set(['$disabled', '$minHeight']);

export const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],
  width: '100%',
}));

export const StyledBody = styled('div', {
  shouldForwardProp: (prop) => !TRANSIENT_PROPS.has(prop as string),
})<{ $disabled: boolean }>(({ theme, $disabled }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  boxSizing: 'border-box',
  overflow: 'hidden',
  borderRadius: theme.radius[8],
  border: `1px solid ${theme.colors.border.default}`,
  backgroundColor: theme.colors.background.overlay,
  opacity: $disabled ? 0.5 : 1,
  cursor: $disabled ? 'not-allowed' : 'text',
}));

export const StyledContent = styled('div', {
  shouldForwardProp: (prop) => !TRANSIENT_PROPS.has(prop as string),
})<{ $minHeight: number }>(({ theme, $minHeight }) => ({
  flex: 1,
  minHeight: $minHeight,
  overflowY: 'auto',
  ...scrollbarStyles,

  '& .ProseMirror': {
    ...typographyVariantStyles.body2,
    outline: 'none',
    minHeight: $minHeight,
    boxSizing: 'border-box',
    padding: theme.spacing[16],
    color: theme.colors.text.primary,
  },

  '& .ProseMirror p': {
    margin: 0,
  },

  '& .ProseMirror p + p': {
    marginTop: theme.spacing[16],
  },

  '& .ProseMirror a': {
    color: theme.colors.info.text,
  },

  '& .ProseMirror p.is-editor-empty:first-of-type::before': {
    content: 'attr(data-placeholder)',
    float: 'left',
    height: 0,
    pointerEvents: 'none',
    color: theme.colors.text.tertiary,
  },
}));

export const StyledToolbar = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[16],
  padding: theme.spacing[16],
  borderTop: `1px solid ${theme.colors.border.default}`,
}));

export const StyledToolbarRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing[8],
}));

export const StyledCounter = styled('div')(({ theme }) => ({
  ...typographyVariantStyles.body2,
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing[16],
  borderTop: `1px solid ${theme.colors.border.default}`,
  color: theme.colors.text.secondary,
}));

export const StyledStylePicker = styled('div')({
  width: 180,
});

export const StyledLinkDialogBody = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[16],
  width: '100%',
}));
